export default class ImageProxyHelper {


    /*
    * https://image.darkube.app/_/resize:fill:300:400/quality:10/url is here.webp
    *
    * */
    static Builder = class {
        constructor(imageUrl) {
            this.imageUrl = btoa(imageUrl.replaceAll('http:', 'https:'));
        }

        baseUrl = "https://cdn.poupeh.ir/_";

        compressSize = ""
        filters = []

        setImageCompressSize(width, height) {
            try {
                const _width = parseInt(width)
                const _height = parseInt(height)

                if (_width > 0 && _height > 0) {
                    this.compressSize = `/resize:fill:${width}:${height}`
                }

            } catch (e) {
                this.compressSize = ``
            }
            return this
        }

        changeQuality(percent = 100) {
            this.filters.push(`/quality:${percent}`)

            return this
        }

        build() {
            let finalUrl = this.baseUrl;
            finalUrl += this.compressSize;

            let _filters = ""
            this.filters.map((item, index) => {
                _filters += `${item}`
            })

            finalUrl += _filters

            finalUrl += `/${this.imageUrl}.webp`

            return finalUrl
        }

    }
}
